import { buildURI, useFetch } from '@hn-front/utils';
import { ASSIGNMENTS_API } from '../constants/routes';
var useGroupInfo = function (groupId) {
    return useFetch(buildURI(ASSIGNMENTS_API.groupInfo, { pathParams: { groupId: groupId } }));
};
export { useGroupInfo };
